import { Box, Flex } from "@chakra-ui/layout";
import { useColorModeValue } from "@chakra-ui/react";
import React from "react";
import FormLoadingOverlay from "./FormLoadingOverlay";
import { lightMode, darkMode } from "../../lib/models/color-mode-colors";

function FormSkeletonLoader() {
  const loadingOverlayBg = useColorModeValue(lightMode[100], darkMode[200]);
  return (
    <Flex>
      <Box
        position="relative"
        width="full"
        backgroundColor={loadingOverlayBg}
        height="calc(100vh - 70px)"
        padding={{ base: 1, md: 4 }}
      >
        <FormLoadingOverlay label="Loading Quote..." />
      </Box>
    </Flex>
  );
}

export default FormSkeletonLoader;
